import { render, staticRenderFns } from "./classStudy.vue?vue&type=template&id=8db7e08c&scoped=true"
import script from "./classStudy.vue?vue&type=script&lang=js"
export * from "./classStudy.vue?vue&type=script&lang=js"
import style0 from "./classStudy.vue?vue&type=style&index=0&id=8db7e08c&prod&lang=scss"
import style1 from "./classStudy.vue?vue&type=style&index=1&id=8db7e08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db7e08c",
  null
  
)

export default component.exports